import SearchFormInputRedirect from './SearchFormInputRedirect';

export default SearchFormInputRedirect;
